import theme from 'theme/index';
import { RuntimeConfig } from 'config/config.types';
import { productionColor } from 'theme/palette';

export const switchTheme = (runtimeConfig: RuntimeConfig) => {
  theme.palette.primary.main = runtimeConfig.bannerColour ?? productionColor;
};
